import { z } from "zod";
import { MODEL_NAME, DESCRIPTION } from "./consts";

export const schema = z.object({
  [MODEL_NAME]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
});

export type AddModelFormValues = z.infer<typeof schema>;
